module.exports = __webpack_public_path__ + "img/Plan de travail 16@2x-100.8d39de59.jpg";